export const translateError = (errorCode) => {
    if (errorCode === "Firebase: Error (auth/email-already-in-use).") return "Tento email sa už používa. Zvoľ si iný.";
    if (errorCode === "alias-already-taken") return "Tento ALIAS sa už používa. Zvoľ si iný.";
    return errorCode;
}